import { c as _c } from "react-compiler-runtime";
import InfiniteScrollMarker from '../../infiniteScroll/InfiniteScrollMarker';
import { DEFAULT_COLUMN_WIDTH, TABLE_ROW_HEIGHT } from '../../table/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const TableFooter = t0 => {
  const $ = _c(4);
  const {
    infiniteScrollConfig,
    handleIntersectionChange,
    scrollContainerRef
  } = t0;
  if (!infiniteScrollConfig.hasNextCursor) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      border: "none",
      blockSize: "1px",
      padding: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleIntersectionChange || $[2] !== scrollContainerRef) {
    t2 = /*#__PURE__*/_jsx("tfoot", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          style: t1,
          children: /*#__PURE__*/_jsx(InfiniteScrollMarker, {
            handleIntersectionChange: handleIntersectionChange,
            scrollContainerRef: scrollContainerRef,
            rootMargin: `${TABLE_ROW_HEIGHT * 10}px ${DEFAULT_COLUMN_WIDTH * 5}px`
          })
        })
      })
    });
    $[1] = handleIntersectionChange;
    $[2] = scrollContainerRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TableFooter;